import { render, staticRenderFns } from "./PermanentVinylItem.vue?vue&type=template&id=4deb4489&scoped=true"
import script from "./PermanentVinylItem.vue?vue&type=script&lang=js"
export * from "./PermanentVinylItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb4489",
  null
  
)

export default component.exports